import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { FormService } from 'src/app/services/form';
import { MatSnackBar } from '@angular/material';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { ProposalService } from 'src/app/services/proposal.service';
import { Constants } from 'src/app/core/constants';
import Helper from 'src/app/core/utility/helper';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';

import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-proposallogistics',
    templateUrl: './proposallogistics.component.html',
    styleUrls: ['./proposallogistics.component.scss'],
})
export class ProposalLogisticsComponent extends BasePage implements OnInit {
    stackabilityOptionsList: any[] = [];
    isRotatableOptionsList: any[] = [];
    IsRotatableChecked: boolean = true;
    IsStackHeightLessThanTruckHeight: boolean = undefined;
    childControlTooltipText: string = '';
    transportModeId: number;
    totalWeight: number;
    containerMaxLoadWeight: number;
    partWeightInProposal: number;
    lowUtilizationThreshold: number;
    weightUtilization: number;
    cubeUtilization: number;
    sourceTypeId: number;

    currentPackageLength: number;
    currentPackageWidth: number;
    currentPackageHeight: number;
    currentPackageWeight: number;
    currentPackageTotalPartQuantity: number;
    currentIsStackable: boolean;
    currentNofStackableUnitsForShipping: number;
    currentIsRotatable: boolean;
    createProposalDTO: CreateProposalDTO;

    tooltip_stackability =
        'Stackability is the ability to put unit loads (pallets) on top of each other for shipping/warehousing without damaging the structural integraty of any of the packaging layers or damaging the internal content';
    tooltip_NoOfStackableUnitsForShipping =
        'How many unit load can be safely stacked on top of each other including bottom layer during shipping?';
    tooltip_NoOfStackableUnitsForWarehousing =
        'How many unit load can be safely stacked on top of each other including bottom layer in warehouse?';
    transportModeTips =
        'If the ship mode is incorrect, please go to the basic info tab and update it';

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        logger: NGXLogger,
        appSettings: AppSettings,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        public snackbar: MatSnackBar
    ) {
        super(localstorageService, logger, appSettings);
        this.proposalLogisticsInfoForm = this.fb.group({
            TotalWeight: [null],
            TotalPartQuantity: [null],
            WeightUtilization: [null],
            CubeUtilization: [null],
            ContainerLength: [null],
            ContainerWidth: [null],
            ContainerHeight: [null],
            MaxLoadWeight: [null],
            LowUtilizationComments: [''],
            Container: [null],
            TransportMode: [null],
            IsStackable: [null, [Validators.required]],
            IsRotatable: [true, [Validators.required]],
            RotationComment: [null],
            NonStackabilityReason: [null],
            NoOfStackableUnitsForShipping: [null],
            NoOfStackableUnitsForWarehousing: [null],
        });
        this.stackabilityOptionsList.push({
            Description: 'Stackable',
            Value: true,
        });
        this.stackabilityOptionsList.push({
            Description: 'Non-Stackable',
            Value: false,
        });
        this.isRotatableOptionsList.push({
            Description: 'Yes',
            Value: true,
        });
        this.isRotatableOptionsList.push({
            Description: 'No',
            Value: false,
        });
    }
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    proposalLogisticsInfoForm: FormGroup;
    highestTabIndex: number = 0;
    container: ContainerDetails;
    proposalSummary: CreateProposalDTO = new CreateProposalDTO();
    @Output() private formReady: EventEmitter<FormGroup> =
        new EventEmitter<FormGroup>();
    @Input() isUpdateMode = false;
    @Output() tabChangeRequested = new EventEmitter<number>();
    @Output() formUpdated = new EventEmitter<number>();
    public formErrorsProposalLogistics = {
        LowUtilizationComments: '',
        RotationComment: '',
        IsStackable: '',
        NonStackabilityReason: '',
        NoOfStackableUnitsForShipping: '',
        NoOfStackableUnitsForWarehousing: '',
    };
    ngOnInit() {
        this.getLowUtilizationThreshold();
        this.createProposalDTO = new CreateProposalDTO();
        this.proposalService.proposalEstimate.subscribe((estimate) => {
            if (estimate && !this.isUpdateMode) {
                this.createProposalDTO.EstimateProposal = estimate;

                let maxPackageLevelEstimate = estimate.find(
                    (x) => x.PackageLevelId == estimate.length
                );

                this.createProposalDTO.DefaultProposal.PackageInfo.IsStackable =
                    maxPackageLevelEstimate.IsStackable;
                if (maxPackageLevelEstimate.IsStackable) {
                    this.createProposalDTO.DefaultProposal.PackageInfo.NoOfStackableUnitsForShipping =
                        maxPackageLevelEstimate.NoOfStackableUnitsForShipping as number;
                    this.createProposalDTO.DefaultProposal.PackageInfo.NoOfStackableUnitsForWarehousing =
                        maxPackageLevelEstimate.NoOfStackableUnitsForWarehousing as number;
                } else {
                    this.createProposalDTO.DefaultProposal.PackageInfo.NonStackabilityReason =
                        maxPackageLevelEstimate.NonStackabilityReason;
                }

                this.createProposalDTO.DefaultProposal.PackageInfo.IsRotatable =
                    true;
                this.updateControls(this.createProposalDTO);
            }
        });

        this.proposalService.globalUOMOnUserToggle.subscribe((uom) => {
            if (uom) {
                this.globalUOM = uom;
            }
        });

        this.proposalService.globalUOMOnLoad.subscribe((uom) => {
            if (uom) {
                this.globalUOM = uom;
            }
        });

        this.proposalService.transportModeId.subscribe((id) => {
            if (id) {
                this.transportModeId = id;
                this.getContainer(this.sourceTypeId, this.transportModeId);
            }
        });

        this.proposalService.transportModeDescription.subscribe(
            (transportModeDescription) => {
                if (transportModeDescription) {
                    this.proposalLogisticsInfoForm.patchValue({
                        TransportMode: transportModeDescription,
                    });
                }
            }
        );

        this.proposalService.sourceTypeId.subscribe((id) => {
            if (id) {
                this.sourceTypeId = id;
                this.getContainer(this.sourceTypeId, this.transportModeId);
            }
        });

        this.proposalService.globalUOMOnSubmit.subscribe((uom) => {
            if (uom) {
                if (uom.Id != this.globalUOM.Id) {
                    this.globalUOM = uom;
                    this.setUtilization(
                        this.currentPackageLength,
                        this.currentPackageWidth,
                        this.currentPackageHeight,
                        this.currentPackageWeight,
                        this.currentPackageTotalPartQuantity,
                        this.currentIsStackable,
                        this.currentNofStackableUnitsForShipping,
                        this.currentIsRotatable
                    );
                }
            }
        });

        this.proposalService.createProposalDTO.subscribe((prop) => {
            this.transportModeId =
                prop.DefaultProposal.PackageInfo.TransportModeId;
            if (prop.DefaultProposal.LowUtilizationComments != undefined) {
                this.proposalLogisticsInfoForm.patchValue({
                    LowUtilizationComments:
                        prop.DefaultProposal.LowUtilizationComments,
                    TransportMode:
                        prop.DefaultProposal.PackageInfo
                            .TransportModeDescription,
                });
            }
            this.updateControls(prop);
            this.getContainer(this.sourceTypeId, this.transportModeId);
        });

        (<FormGroup>(
            this.proposalLogisticsInfoForm.controls['LowUtilizationComments']
        )).valueChanges.subscribe((data) => {
            if (
                data != '' ||
                !this.container ||
                this.container.container == ''
            ) {
                this.proposalLogisticsInfoForm.controls[
                    'LowUtilizationComments'
                ].setErrors(null);
                this.formErrorsProposalLogistics.LowUtilizationComments = '';
                this.updateUtilization();
                this.formReady.emit(this.proposalLogisticsInfoForm);
            }

            // this.formUpdated.emit();
        });
        (<FormGroup>(
            (this.proposalLogisticsInfoForm.controls['NonStackabilityReason'],
            this.proposalLogisticsInfoForm.controls['IsRotatable'],
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ])
        )).valueChanges.subscribe((data) => {
            this.updateUtilization();
            this.formUpdated.emit();
        });

        (<FormGroup>(
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForWarehousing'
            ]
        )).valueChanges.subscribe((data) => {
            this.updateUtilization();
            this.formUpdated.emit();
        });

        this.formReady.emit(this.proposalLogisticsInfoForm);
    }

    updateUtilization() {
        this.setUtilization(
            this.currentPackageLength,
            this.currentPackageWidth,
            this.currentPackageHeight,
            this.currentPackageWeight,
            this.currentPackageTotalPartQuantity,
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value > 1,
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value,
            this.proposalLogisticsInfoForm.controls['IsRotatable'].value
        );
        this.IsStackableChanged();
    }

    getLowUtilizationThreshold() {
        this.dataService
            .getAppSettingsByKey('LowUtilizationThreshold')
            .subscribe((response: any) => {
                if (
                    response.Success &&
                    response.Data &&
                    response.Data.ParameterValue
                ) {
                    this.lowUtilizationThreshold = response.Data.ParameterValue;
                }
            });
    }

    getContainer(sourceTypeId: number, transportModeId: number): any | null {
        const containerDetails = getContainerDetails(
            sourceTypeId,
            transportModeId
        );
        this.container = containerDetails;
        if (containerDetails != null) {
            if (this.globalUOM.Id == Constants.METRIC_UOM_ID) {
                containerDetails.length = Helper.roundto8(
                    containerDetails.length * Constants.IMPERIAL_DIM_FACTOR
                );
                containerDetails.width = Helper.roundto8(
                    containerDetails.width * Constants.IMPERIAL_DIM_FACTOR
                );
                containerDetails.height = Helper.roundto8(
                    containerDetails.height * Constants.IMPERIAL_DIM_FACTOR
                );
                containerDetails.weight = Helper.roundto8(
                    containerDetails.weight / Constants.IMPERIAL_WEIGHT_FACTOR
                );
            }
            this.containerMaxLoadWeight = containerDetails.weight;
            this.proposalLogisticsInfoForm.patchValue({
                ContainerLength: containerDetails.length,
                ContainerWidth: containerDetails.width,
                ContainerHeight: containerDetails.height,
                MaxLoadWeight: containerDetails.weight,
                Container: containerDetails.container,
            });
        }
    }

    ValidateForm(isForSubmit: boolean = true) {
        this.formErrorsProposalLogistics.LowUtilizationComments = '';

        this.proposalLogisticsInfoForm.controls[
            'LowUtilizationComments'
        ].setErrors(null);

        this.proposalLogisticsInfoForm.controls['RotationComment'].setErrors(
            null
        );
        this.proposalLogisticsInfoForm.controls[
            'NonStackabilityReason'
        ].setErrors(null);
        this.proposalLogisticsInfoForm.controls[
            'NoOfStackableUnitsForShipping'
        ].setErrors(null);
        this.proposalLogisticsInfoForm.controls[
            'NoOfStackableUnitsForWarehousing'
        ].setErrors(null);
        this.formErrorsProposalLogistics.RotationComment = '';
        this.formErrorsProposalLogistics.NonStackabilityReason = '';
        this.formErrorsProposalLogistics.NoOfStackableUnitsForShipping = '';
        this.formErrorsProposalLogistics.NoOfStackableUnitsForWarehousing = '';

        if (
            this.IsRotatableChecked == undefined ||
            this.IsStackHeightLessThanTruckHeight == undefined
        )
            return;

        if (
            !this.IsRotatableChecked &&
            Helper.isNullOrSpaces(
                this.proposalLogisticsInfoForm.controls['RotationComment'].value
            )
        ) {
            this.proposalLogisticsInfoForm.controls[
                'RotationComment'
            ].setErrors({
                required: true,
            });
        }
        if (this.transportModeId == 3) return;
        if (
            this.IsStackHeightLessThanTruckHeight &&
            Helper.isNullOrSpaces(
                this.proposalLogisticsInfoForm.controls['NonStackabilityReason']
                    .value
            )
        ) {
            this.formErrorsProposalLogistics.NonStackabilityReason =
                'Please provide a comment why the stack height is less than truck height';
            this.proposalLogisticsInfoForm.controls[
                'NonStackabilityReason'
            ].setErrors({
                required: true,
            });
        }

        if (
            !this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value
        ) {
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].setErrors({ required: true });
        }
        if (
            !this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForWarehousing'
            ].value
        ) {
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForWarehousing'
            ].setErrors({ required: true });
        }

        if (
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value
        ) {
            const Max = Constants.StackabilityParameterMaxValue;
            var noOfStackForShipping =
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForShipping'
                ].value;
            if (noOfStackForShipping > Max) {
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForShipping'
                ].setErrors({ max: true, maxValue: Max });
                this.formErrorsProposalLogistics.NoOfStackableUnitsForShipping =
                    'Value should be less than or equal to ' + Max;
            }

            if (noOfStackForShipping < 1) {
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForShipping'
                ].setErrors({ min: true, minValue: 1 });
                this.formErrorsProposalLogistics.NoOfStackableUnitsForShipping =
                    'Value should be greater than ' + 1;
            }

            if (
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForWarehousing'
                ].value < noOfStackForShipping
            ) {
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForShipping'
                ].setErrors({
                    min: true,
                    minValue: noOfStackForShipping,
                });
                this.formErrorsProposalLogistics.NoOfStackableUnitsForWarehousing =
                    'Cannot be less than # of unit loads stackable for transportation: ' +
                    noOfStackForShipping;
            }
        }

        if (!this.container || this.container.container == '' || !isForSubmit)
            return;

        if (
            this.proposalLogisticsInfoForm.controls['LowUtilizationComments']
                .value &&
            this.proposalLogisticsInfoForm.controls['LowUtilizationComments']
                .value.length > 0
        )
            return;

        if (this.cubeUtilization >= this.lowUtilizationThreshold) return;

        this.proposalLogisticsInfoForm.controls[
            'LowUtilizationComments'
        ].setErrors({ required: true });
        this.formErrorsProposalLogistics.LowUtilizationComments =
            'Utilization is low. Please provide a reason or consider optimizing.';
    }

    IsRotatableChanged(value: any) {
        if (value) {
            this.IsRotatableChecked = true;
        } else {
            this.IsRotatableChecked = false;
        }
        this.updateUtilization();
    }

    IsStackableChanged() {
        let noOfStackForShipping =
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value;

        this.proposalLogisticsInfoForm.controls['IsStackable'].setValue(
            noOfStackForShipping > 1
        );

        if (
            !this.container ||
            this.container.container == '' ||
            this.transportModeId == 3
        )
            return;

        let totalWeight =
            this.proposalLogisticsInfoForm.controls['TotalWeight'].value;

        let totalWeightPerLayer = totalWeight / noOfStackForShipping;
        this.IsStackHeightLessThanTruckHeight =
            noOfStackForShipping <= 1 ||
            (totalWeight + totalWeightPerLayer < this.container.weight &&
                this.currentPackageHeight * (noOfStackForShipping + 1) <
                    this.container.height);
    }

    updateControls(prop: CreateProposalDTO) {
        this.IsRotatableChecked = prop.DefaultProposal.PackageInfo.IsRotatable;
        this.proposalLogisticsInfoForm.controls['IsStackable'].setValue(
            prop.DefaultProposal.PackageInfo.IsStackable
        );
        this.IsStackableChanged();
        this.proposalLogisticsInfoForm.controls[
            'NonStackabilityReason'
        ].setValue(prop.DefaultProposal.PackageInfo.NonStackabilityReason);
        this.proposalLogisticsInfoForm.controls[
            'NoOfStackableUnitsForShipping'
        ].setValue(
            prop.DefaultProposal.PackageInfo.NoOfStackableUnitsForShipping
        );
        this.proposalLogisticsInfoForm.controls[
            'NoOfStackableUnitsForWarehousing'
        ].setValue(
            prop.DefaultProposal.PackageInfo.NoOfStackableUnitsForWarehousing
        );

        this.proposalLogisticsInfoForm.controls['IsRotatable'].setValue(
            prop.DefaultProposal.PackageInfo.IsRotatable
        );
        this.proposalLogisticsInfoForm.controls['RotationComment'].setValue(
            prop.DefaultProposal.PackageInfo.RotationComment
        );
    }

    setUtilization(
        packageLength: number,
        packageWidth: number,
        packageHeight: number,
        packageWeight: number,
        packageTotalPartQuantity: number,
        isStackable: boolean,
        nofStackableUnitsForShipping: number,
        isRotatable: boolean
    ) {
        this.getContainer(this.sourceTypeId, this.transportModeId);
        this.currentPackageLength = packageLength;
        this.currentPackageWidth = packageWidth;
        this.currentPackageHeight = packageHeight;
        this.currentPackageWeight = packageWeight;
        this.currentPackageTotalPartQuantity = packageTotalPartQuantity;
        this.currentIsStackable = isStackable;
        this.currentNofStackableUnitsForShipping = nofStackableUnitsForShipping;
        this.currentIsRotatable = isRotatable;

        if (!this.container || this.container.container == '') {
            this.proposalLogisticsInfoForm.patchValue({
                TotalWeight: '',
                WeightUtilization: '',
                CubeUtilization: '',
                TotalPartQuantity: '',
                ContainerLength: '',
                ContainerWidth: '',
                ContainerHeight: '',
            });
            return;
        }

        let weightUtilization = 0;
        let cubeUtilization = 0;
        let containerLength = this.container.length;
        let containerWidth = this.container.width;
        let containerHeight = this.container.height;
        let containerWeight = this.container.weight;
        let containerVolume =
            containerLength * containerWidth * containerHeight;

        // Calculate number of units that can fit into the container
        let unitsLengthwise = Math.max(
            Math.floor(containerLength / packageLength),
            1
        );
        let unitsWidthwise = Math.max(
            Math.floor(containerWidth / packageWidth),
            1
        );
        let unitsHeightwise = isStackable ? nofStackableUnitsForShipping : 1;
        let totalUnits = unitsLengthwise * unitsWidthwise * unitsHeightwise;

        // If the unit load is rotatable, calculate the alternative orientation
        if (isRotatable) {
            let altUnitsLengthwise = Math.max(
                Math.floor(containerLength / packageWidth),
                1
            );
            let altUnitsWidthwise = Math.max(
                Math.floor(containerWidth / packageLength),
                1
            );
            let altTotalUnits =
                altUnitsLengthwise * altUnitsWidthwise * unitsHeightwise;

            // Take the maximum of both orientations
            totalUnits = Math.max(totalUnits, altTotalUnits);
        }

        // Corrected calculation for total weight
        let totalWeight = totalUnits * packageWeight;
        let totalVolume =
            totalUnits * packageLength * packageWidth * packageHeight;

        // Calculate utilization percentages
        weightUtilization = (totalWeight / containerWeight) * 100;
        cubeUtilization = (totalVolume / containerVolume) * 100;

        // Calculate the final total part quantity that can fit into the container
        let finalTotalPartQuantity = totalUnits * packageTotalPartQuantity;

        // Patch the form values
        this.weightUtilization = Helper.roundto3(weightUtilization);
        this.cubeUtilization = Helper.roundto3(cubeUtilization);
        this.proposalLogisticsInfoForm.patchValue({
            TotalWeight: Helper.roundto3(totalWeight),
            WeightUtilization: this.weightUtilization,
            CubeUtilization: this.cubeUtilization,
            TotalPartQuantity: Helper.roundto3(finalTotalPartQuantity),
        });
        this.ValidateForm();
    }

    isLowLogisticsUtilization() {
        if (!this.container || this.container.container == '') return false;
        return this.cubeUtilization < this.lowUtilizationThreshold;
    }

    isAboveUtilizationLimit() {
        if (!this.container || this.container.container == '') return false;
        if (this.cubeUtilization > 100 && this.weightUtilization > 100)
            return 'Cube Utilization & Weight Utilization';
        if (this.cubeUtilization > 100) return 'Cube Utilization';
        if (this.weightUtilization > 100) return 'Weight Utilization';
        return '';
    }

    getDimensionUOMName() {
        if (this.globalUOM) {
            return this.globalUOM.DimensionUoMName;
        } else {
            return '';
        }
    }
    getWeightUOMName() {
        if (this.globalUOM) {
            return this.globalUOM.WeightUoMName;
        } else {
            return '';
        }
    }
}
// TODO: Below will be moved to DB in next release(if needed)
type ContainerDetails = {
    region: string;
    shipMode: string;
    container: string;
    length: number;
    width: number;
    height: number;
    weight?: number;
};

function getContainerDetails(
    sourcetypeId: number,
    shipmode: number
): ContainerDetails | null {
    const sourcetypeToRegionMap: { [key: number]: string } = {
        56: 'North America',
        64: 'North America',
        104: 'North America',
        1315: 'North America',
        1682: 'North America',
        58: 'North America',
        1109: 'China',
        331: 'China',
        2222: 'China',
        935: 'China',
        909: 'EMEA',
        668: 'EMEA',
    };

    const region = sourcetypeToRegionMap[sourcetypeId];
    if (!region) return null;

    const shipModeMap: { [key: number]: string } = {
        1: 'Ocean',
        2: 'Ground',
        3: 'Air',
    };

    const shipMode = shipModeMap[shipmode];
    if (!shipMode) return null;

    const containerData: {
        [key: string]: { [key: string]: ContainerDetails };
    } = {
        'North America': {
            Ground: {
                region,
                shipMode,
                container: '53" Trailer',
                length: 628,
                width: 96,
                height: 104.4,
                weight: 43000,
            },
            Ocean: {
                region,
                shipMode,
                container: '40" High Cube',
                length: 468,
                width: 90,
                height: 100,
                weight: 44000,
            },
            Air: {
                region,
                shipMode,
                container: '',
                length: 0,
                width: 0,
                height: 0,
            },
        },
        China: {
            Ground: {
                region,
                shipMode,
                container: 'Trailer',
                length: 469,
                width: 93,
                height: 93,
                weight: 43000,
            },
            Ocean: {
                region,
                shipMode,
                container: '40" High Cube',
                length: 468,
                width: 90,
                height: 100,
                weight: 44000,
            },
            Air: {
                region,
                shipMode,
                container: '',
                length: 0,
                width: 0,
                height: 0,
            },
        },
        EMEA: {
            Ground: {
                region,
                shipMode,
                container: 'Trailer',
                length: 535.8,
                width: 97.6,
                height: 118.5,
                weight: 52910,
            },
            Ocean: {
                region,
                shipMode,
                container: '40" High Cube',
                length: 468,
                width: 90,
                height: 100,
                weight: 44000,
            },
            Air: {
                region,
                shipMode,
                container: '',
                length: 0,
                width: 0,
                height: 0,
            },
        },
        'Non China APAC': {
            Ground: {
                region,
                shipMode,
                container: 'Trailer',
                length: 0,
                width: 0,
                height: 0,
            },
            Ocean: {
                region,
                shipMode,
                container: '40" High Cube',
                length: 468,
                width: 90,
                height: 100,
                weight: 44000,
            },
            Air: {
                region,
                shipMode,
                container: '',
                length: 0,
                width: 0,
                height: 0,
            },
        },
    };

    return containerData[region][shipMode] || null;
}
